import React, { useState, useEffect } from 'react';
import './LoginPage.css';
import { verifyPassword } from '../utils/apiService';

function VerifyPassword({ onVerified, userName }) {
  const [formData, setFormData] = useState({
    password: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Enable scrolling on body when verify password page is mounted
  useEffect(() => {
    document.body.style.overflow = 'auto';
    document.body.classList.add('login-page-active');
    
    return () => {
      document.body.style.overflow = '';
      document.body.classList.remove('login-page-active');
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validate = () => {
    const newErrors = {};
    
    if (!formData.password) {
      newErrors.password = 'Password is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validate()) {
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    try {
      await verifyPassword(formData.password);
      // Password verified, proceed
      onVerified({
        password: formData.password
      });
    } catch (error) {
      setErrors({ password: error.message || 'Invalid password' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
        
          <h1>Verify Site Password</h1>
          {userName && (
            <p className="login-subtitle">Welcome back, {userName}</p>
          )}
          <p className="login-subtitle">
            To avoid unauthorized access,
            please enter the site password to continue. Reached out to Admin to asked for site password.</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {/* Password Field */}
          <div className="form-group">
            <label htmlFor="password">Site Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter the site password"
              className={errors.password ? 'error' : ''}
              autoFocus
            />
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>

          <button 
            style={{background:'#000000'}}
            type="submit" 
            className="login-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Verifying...' : 'Verify Site Password'}
          </button>
        </form>

        <div className="disclaimer-footer">
          <h4>Disclaimer:</h4>
          <p>
            This application uses Generative Artificial Intelligence (AI) to produce responses based on patterns in data. 
            AI‑generated output may be inaccurate, incomplete, biased, or out‑of‑date, and should not be relied on as a 
            sole source of truth. Users are responsible for reviewing, validating, and independently verifying any information 
            before using it in decision‑making.
          </p>
          <p>By using this application, you acknowledge that:</p>
          <ul>
            <li>You understand you are interacting with an AI system.</li>
            <li>AI‑generated content may contain errors or omissions and does not constitute professional advice.</li>
            <li>You must not input confidential, personal, or proprietary information unless you are authorised to do so, 
                as described in your organization's data handling policies.</li>
            <li>You remain fully accountable for how you use the information provided.</li>
          </ul>
          <p>
            The organization is not liable for any decisions or actions taken based on AI‑generated content. 
            Use of this tool is subject to applicable AI governance, privacy, and security policies.
          </p>
        </div>
      </div>
    </div>
  );
}

export default VerifyPassword;
